import { useWebsocket } from 'contexts/websocket';
import { useEffect } from 'react';
import { CHAT_COMPLETED_TYPE, CHAT_RECEIVE_MESSAGE_TYPE } from 'utils/chat/chatConstants';
import { getAiChatPayload } from 'utils/chat/chatHelpers';

/**
 * Completion-event listener for AI chat responses.
 *
 * Use when summary state should refresh after an assistant response is persisted.
 * It ignores in-progress `receive_ai_message` chunks and calls `onCompleted(payload, event)`
 * only for completion events or `receive_ai_message` events marked `done`.
 *
 * @param {Function} onCompleted Receives `(payload, websocketMessage)` for completed responses.
 * @returns {void}
 */
const useCompletedChatMessage = (onCompleted) => {
    const { onMessage } = useWebsocket();

    useEffect(() => {
        if (!onCompleted) return;

        const cleanup = onMessage((websocketMessage) => {
            if (websocketMessage.type !== CHAT_COMPLETED_TYPE && websocketMessage.type !== CHAT_RECEIVE_MESSAGE_TYPE) {
                return;
            }

            const payload = getAiChatPayload(websocketMessage);
            if (websocketMessage.type === CHAT_RECEIVE_MESSAGE_TYPE && !payload.done) return;

            onCompleted(payload, websocketMessage);
        });

        return cleanup;
    }, [onCompleted, onMessage]);
};

export default useCompletedChatMessage;
